import React from "react";
import { Panel } from "../../components/panels";
import AdvancingProvideListItem from "./AdvancingProvideListItem";

interface Props {
  config: server.dto.DashboardAdvancingProvidePanelConfig
}

const AdvancingProvidePanel = (props: Props) => {
  return <Panel
    panelClassName="s1_dashboard-panel"
    title={props.config.headerLabel}
    subTitle={RESX.Advancing.PleaseProvideInformation}
  >
    <div className="list-with-gaps line-layout advancing-list advancing-list-provide">
      <div className="list-with-gaps-body">
        {props.config.data.map((item, idx) =>
          <AdvancingProvideListItem key={idx} item={item} />
        )}
      </div>
    </div>
  </Panel >;
};

export default AdvancingProvidePanel;